module.exports = __webpack_public_path__ + "static/media/colorful-border.cad7eef6.svg";